module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/align-right.svg?d8aa809c16c4e728b7c0a490161a6175";